var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTreatmentSummaryNumbers = function SvgTreatmentSummaryNumbers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D6D6D6",
    d: "m26.5 23.59-2.06-.38a1.69 1.69 0 0 0 1.16-1.61 1.71 1.71 0 0 0-1.3-1.66l-4.35-1.08 3.52.88a1.712 1.712 0 0 0 .83-3.32l-4.35-1.1 3.52.88a1.712 1.712 0 0 0 .83-3.32l-4.35-1.09-3.91.34V8.28a3.23 3.23 0 0 0-4.24-3v2.35c0 3.06-1 4.61-2.86 7H4v9.17h4.95l11 2.12 5.92 1.1a1.74 1.74 0 0 0 .63-3.42z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4C4C4C",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    d: "m19.95 15.32 3.55.89"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6726",
    d: "M8.94 14.32H4v9.76h4.94z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4C4C4C",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    d: "m19.96 18.85 3.52.88M19.96 22.15l4.49 1.06"
  })));
};
export default SvgTreatmentSummaryNumbers;